var map = {
	"./0-closed.png": 7225,
	"./0-opened.png": 4938,
	"./1-closed.png": 8570,
	"./1-opened.png": 357,
	"./spork-closed.png": 4014,
	"./spork-opened.png": 1505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9435;